export const LOGIN = '/login'
export const RESET_PASSWORD = '/reset-password'
export const SEARCH_INDEX = '/search'
export const PROFILE_INDEX = '/profile'
export const HOME_INDEX = '/'

export const PROFILE_ACCOUNT = PROFILE_INDEX + '/account'
export const PROFILE_BILLING = PROFILE_INDEX + '/billing'
export const PROFILE_USERS = PROFILE_INDEX + '/users'
export const SSO_CONFIG = PROFILE_INDEX + '/sso'

export const ENGINE_SEARCH = SEARCH_INDEX + '/engine'

export const PARTNER_SEARCH = SEARCH_INDEX + '/partner'
export const PATENTABILITY_SEARCH = PARTNER_SEARCH + '/patentability'
export const OPERATION_FREEDOM_SEARCH = PARTNER_SEARCH + '/freedom-to-operate'
export const VALIDITY_SEARCH = PARTNER_SEARCH + '/validity'
export const PARTNER_SEARCH_EDIT = PARTNER_SEARCH + '/[id]/edit'

export const DATA_COVERAGE = '/data-coverage'
export const SAML_REDIRECT = '/saml'

export const HEALTH = '/health'

export const ALLOWED_ROUTES_WITHOUT_AUTH = new Set([
  LOGIN,
  RESET_PASSWORD,
  DATA_COVERAGE,
  PARTNER_SEARCH_EDIT,
  SAML_REDIRECT,
  HEALTH,
  '/_error',
  '/404',
])

const partnerEditRegex = /\/search\/\S+\/edit/
const patentPageRegex = /\/patents\/\S+/

export const isAuthedRoute = (route: string): boolean =>
  !ALLOWED_ROUTES_WITHOUT_AUTH.has(route) &&
  !partnerEditRegex.test(route) &&
  !patentPageRegex.test(route)
